import {useQuery} from "react-query"
import {LoraDeviceApi} from "api/lora-device.api"

export const useFindAllLoraDevice = (page: number = 0, pageSize: number = 10, search: string = "") => {
    return useQuery(["findAllLoraDevice", page, pageSize, search], () => {
        const result = LoraDeviceApi.findAllLoraDevice(page, pageSize, search)
        console.log("result : ", result, "page : ", page, "pageSize : ", pageSize)
        return result
    }, {
        refetchIntervalInBackground: false,
        refetchOnMount: true,
        cacheTime: 0
    })
}